import { useActions } from '.';
import { LockerMqtt } from '../devices/locker/impl/LockerMqtt';
import { LockerStub } from '../devices/locker/impl/LockerStub';
import { LockerWS } from '../devices/locker/impl/LockerWS';
import { Logger } from '../devices/logger/interface/Logger';

export const useLocker = () => {
  const { setLockerAction } = useActions();
  const setLocker = async (logger: Logger) => {
    console.log('set locker');
    const locker = new LockerWS(logger);
    setLockerAction(locker);
  };
  return [setLocker] as const;
};
